module.exports = __webpack_public_path__ + "img/ice-climbers-min.02a30c1c.png";